import axios, { AxiosRequestConfig } from 'axios';
import U from './Utils';
import CSharpUtils from './CSharpUtils';

/** En forsendelseskode med transportør (tom streng når koden ikke er i bruk). */
export interface ShippingCodeDto {
  code: string;
  carrierName: string;
}

/** Svar fra GET {WEBAPI_PATH}/NE01/shippingcodes */
export interface GetShippingCodesResult {
  found: boolean;
  message: string;
  items: ShippingCodeDto[];
}

export interface UpdateShippingCodeResult {
  updated: boolean;
  message: string;
  code: string;
  carrierName: string;
}

export interface DeleteShippingCodeResult {
  deleted: boolean;
  message: string;
}

const jsonHeaders = () => ({
  'content-type': 'application/json',
  Accept: 'application/json;charset=utf-8',
  Authorization: `Bearer ${CSharpUtils.Get_Token}`,
});

export const getShippingCodes = () => {
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/NE01/shippingcodes`,
    timeout: 20000,
    headers: jsonHeaders(),
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<GetShippingCodesResult>(config);
};

// Koden sendes i body - koder som "/", "%" og "+" tåler ikke å stå i URL-stien.
export const updateShippingCode = (code: string, carrierName: string) => {
  const config = {
    method: 'put',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/NE01/shippingcodes`,
    timeout: 20000,
    headers: jsonHeaders(),
    data: { code, carrierName },
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<UpdateShippingCodeResult>(config);
};

export const deleteShippingCode = (code: string) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/NE01/shippingcodes/delete`,
    timeout: 20000,
    headers: jsonHeaders(),
    data: { code },
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<DeleteShippingCodeResult>(config);
};

/** Excel med radene som matcher søket (kolonnene Kode og Transportør). */
export const exportShippingCodes = (search: string) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/NE01/shippingcodes/export`,
    timeout: 30000,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: { search },
    responseType: 'blob',
  } as AxiosRequestConfig;
  return axios.request<Blob>(config);
};
